module.exports = __webpack_public_path__ + "img/symbol_2.7742eb37.png";